import React, { Fragment, useState, useEffect } from 'react';
import { Spin, Select } from 'antd';
import WrappedNativeTemplateForm from './NativeTemplateForm';
import { urlPath } from '../Settings';
import { getAuthHeader } from '../../utils/security';
import { includes, toLower } from 'lodash';

// const urlPath = "https://acc-aanleveren.persgroep.nl/xServer";
// const urlPath = "https://newsau-test.integration-x.com/xServer";

const { Option } = Select;

const NativeTemplates = React.memo((props) => {
  const { templates, onCancel, childConfig } = props;
  const { record, currentSetTemplate } = childConfig;
  const [currentTemplate2, setCurrentTemplate] = useState(currentSetTemplate);
  let currentTemplate = currentTemplate2;
  if (props.native && !props.internal) {
    currentTemplate = {};
    currentTemplate.key = "Native - All";
    currentTemplate.value = "xandr:39461";
  }
  const [defaultTemplate, setDefaultTemplate] = useState(0);
  const [snippetUpdated, setSnippetUpdated] = useState(false);
  const [selectedTemplate, setSelectedTemplate] = useState(false);
  const [templateFields, setTemplateFields] = useState(false);
  const [admaterial, setAdMaterial] =
    record && record.id ? useState(record.id) : useState(false);
  const [newTemplate, setNewTemplate] = useState(false);
  useEffect(() => {
    if (!templates && admaterial > 0) {
      if (props.native && !props.internal) {
        const { ixTemplateId: value, ixTemplateName: key } = currentTemplate;
        setSelectedTemplate({ value, key });
        setTemplateFields(true);
        setDefaultTemplate(39461);
      }
      else {
        setSelectedTemplate(false);
        setTemplateFields(false);
        setDefaultTemplate(0);
      }
    }
  }, [templates]);

  useEffect(() => {
    if (props.native && !props.internal && admaterial > 0) {
      const url = `${urlPath}/api/adservers/templates/xandr:39461?admaterial=${admaterial}`;
      fetch(url, {
        credentials: 'include',
        headers: getAuthHeader(),
      })
        .then((response) => response.json())
        .then((result) => {
          const { template } = result || false;
          const { id, snippet, variables } = template && template[0];

          return id
            ? setTemplateFields({ id, fields: variables || [], snippet })
            : false;
        })
        .then(setSelectedTemplate(true))
        .catch((err) => console.log(err));
    }
  }, []);

  useEffect(() => {
    if (currentTemplate && !selectedTemplate && admaterial > 0) {
      const {  value, key } = currentTemplate;

      if (!key && !value) {
        const { ixTemplateId, ixTemplateName} = currentTemplate;
        setSelectedTemplate({ value: ixTemplateId, key: ixTemplateName });
        setDefaultTemplate(ixTemplateId);
      } else {
        setSelectedTemplate({ value, key });
        setDefaultTemplate(value);
      }

    }
  }, [currentTemplate, templates]);

  const selectNewTemplate = (id) => {
    if (id > 0) {
      if (selectedTemplate && selectedTemplate.value !== undefined) {
        console.log(selectedTemplate);
        const { value: templateId } = selectedTemplate;
        let tid = templateId;
        if (props.native && !props.internal) tid = "xandr:39461";
        console.log('templateId', tid);
        const url =
          urlPath +
          '/api/adservers/templates/' +
          tid +
          '?admaterial=' +
          id;
        fetch(url, {
          credentials: 'include',
          headers: getAuthHeader(),
        })
          .then((response) => response.json())
          .then((result) => {
            const { template } = result || false;
            const { id, snippet, variables } = template && template[0];
  
            return id /*  && snippet */
              ? setTemplateFields({ id, fields: variables || [], snippet })
              : false;
          })
          .catch((err) => console.log(err));
      }
    }
  }

  useEffect(() => {
    if (admaterial < 0) {
      const { matSpecId } = props;
      const url = `${urlPath}/api/admaterialcreate?matspec=${matSpecId}`
    fetch(url, {
      credentials: 'include',
      headers: getAuthHeader(),
      method: 'POST',
    })
      .then((response) => response.json())
      .then((result) => {
        setAdMaterial(result.admaterial.id);
      })
      .catch((err) => console.log(err));
    } else {
      selectNewTemplate(admaterial);
    }
  }, [selectedTemplate, newTemplate]);

  const updateDataBasedOnAssetProvided = (params) => {
    const { fields, snippet } = templateFields;
    const updatedFields = fields;
    console.log('updatedFields', updatedFields);
    if (updatedFields && updatedFields.length) {
      Object.keys(params).forEach((key) => {
        updatedFields.find((f) =>
          f.label === key ? (f.defaultValue = params[key]) : false
        );
      });
      const newSnippet = updateSnippetBasedOnValues(fields, snippet);
      setTemplateFields({
        ...templateFields,
        fields: updatedFields,
        snippet: newSnippet,
      });
    }
  };

  const updateSnippetBasedOnValues = (fields, snippet) => {
    if (fields && fields.length) {
      let newSnippet = snippet;
      fields.map((field) => {
        const { defaultValue, uniqueName } = field;
        if (defaultValue) {
          const regex = new RegExp(`(\\[%${uniqueName}\\%])`, 'gm');
          newSnippet = newSnippet.replace(regex, defaultValue);
        }
      });
      return newSnippet;
    } else {
      return snippet;
    }
  };

  const handleChange = (value, { key }) => {
    setNewTemplate(true);
    setCurrentTemplate({ ixTemplateId: value, ixTemplateName: key });
    value !== 0
      ? setSelectedTemplate({ value, key }) && setDefaultTemplate(value)
      : false;
  };
  return (
    <div style={{ width: '100%', padding: '20px', textAlign: 'center' }}>
      {templates && templates.length > 0 ? (
        <Fragment>
          {props.internal && (
            <Select
              showSearch
              defaultValue={/*defaultTemplate*/ 0}
              style={{ width: '100%', margin: '0 0 10px' }}
              onChange={handleChange}
              disabled={!props.internal}
              filterOption={(input, { key }) =>
                includes(toLower(key), toLower(input))
              }
            >
              <Option value={0}>Please Select a Template</Option>
              {templates.map((template) => {
                const { id, name } = template;
                const filteredTemplates = [
                  'DPD HLN Takeover (No) Leaderboard Tag Template (Async)',
                  'DPD HLN Takeover Image Template (Async)',
                  'DPD HLN Takeover Leaderboard iFrame URL Template (Async)',
                  'DPD iFrame Template with Clickthrough URL',
                  'DPD iFrame Template WITHOUT Clickthrough URL',
                  'DPD Image Creative',
                  'DPD Native Ads - HLN 2.0 + DM - 300x190 v2 - Branded Content',
                  'DPD Premium 3 Piece Takeover (No) Leaderboard Tag Template (Async)',
                  'DPD Premium 3 Piece Takeover Image Template (Async)',
                  'DPD Premium 3 Piece Takeover Leaderboard iFrame URL Template (Async)',
                  'DPD Fake Creative Async (NEW)',
                  'DPD Tweakers - Advertorial 360x300',
                  'DPD Tweakers - Takeover Image header - NEW',
                  'DPD Tweakers - Takeover Tag-header_NEW',
                  'DPD HLN Takeover Leaderboard + Wallpaper Tag Template (Async) ',
                ];
                {
                  /* return filteredTemplates.includes(name) ? ( */
                }

                return (
                  <Option value={id} key={name}>
                    {id.split(':').pop()} - {name}
                  </Option>
                );
                /*return name.startsWith("DPD Image Creative") ? (
                <Option value={id} key={name}>
                  {name}
                </Option>
              ) : null; */
              })}
            </Select>
          )}
          {templateFields && (
            <WrappedNativeTemplateForm
              native={props.native}
              intern={props.intern}
              specId={props.specId}
              admaterial={admaterial}
              selectedTemplate={selectedTemplate}
              templateFields={templateFields}
              onCancel={onCancel}
              childConfig={{
                ...childConfig,
                updateDataBasedOnAssetProvided,
                updateSnippetBasedOnValues,
              }}
            />
          )}
          {selectedTemplate && !templateFields && (
            <div style={{ padding: '30px 0 0' }}>
              <Spin />
            </div>
          )}
        </Fragment>
      ) : (
          <Spin />
        )}
    </div>
  );
});

export default NativeTemplates;



// WEBPACK FOOTER //
// ./src/components/NativeTemplates/NativeTemplates.js